import { config } from '@/config/config';
import { api } from '@/lib/api-client';
import { checkErrorCode } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';

/**
 * @typedef {object} CruisesAvailabilityResponse
 * @property {number} [errorCode]
 * @property {number[]} data
 */

const path = `cruises/availability/${config.office}/${config.currencyCode}`;

export function useCruisesAvailability() {
  return useQuery({
    queryKey: [path],
    queryFn: async ({ signal }) => {
      const response = await api.get(path, { signal });
      const content = /** @type {{ data: number[] }} */ (await response.json());
      checkErrorCode(content);
      return content.data;
    },
    staleTime: Infinity,
  });
}
